import React from "react"
import { GatsbyImageFluidProps }  from "gatsby-image"
import style from "./grid.module.scss"
var classNames = require("classnames");

type GridAnimProps = { pictureInfo: PictureInfo, src: string, onEnlarge: (PictureInfo, string, number, GridImage) => void | null, onCollapse: (PictureInfo, GridImage) => void | null, index: number};
type GridAnimState = { active: boolean }


class GridAnimation extends React.Component<GridAnimProps, GridAnimState> {
  constructor(props) {
    super(props);
    this.state = {active: false};
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick() {
    if(!this.state.active) {
      this.props?.onEnlarge(this.props.pictureInfo, this.props.src, this.props.index, this);
    } else {
      this.props?.onCollapse(this.props.pictureInfo, this);
    }
    this.setState({active: !this.state.active});
  }
  collapse() {
    if(this.state.active)
      this.setState({active: false});
  }
  render() {
    let classes = {};
    classes[style.gridAnim] = true;
    classes[style.gridAnimBig] = this.state.active;
    return (
      <div className={classNames(classes)} onClick={this.handleClick}>
        <video className={style.gridAnimInternal} autoPlay muted loop playsInline={true} width="100%">
          <source src={this.props.src} type="video/mp4"/>
        </video>
      </div>
  )
  }

}

export default GridAnimation;